<template>
  <div class="default-table scheduler-table">
    <DataTable
      name="scheduler"
      :items="items"
      :tablehdrs="tableheaders.scheduler"
      :search="true"
    >
      <template v-slot:default="{ item }">
        <tr
          :key="item.UUID"
          @dblclick="$emit('view', item)"
          class="table-row"
          :class="getStatus(item.status).class"
        >
          <td>
            <strong>{{ item.id }}</strong>
          </td>
          <td>
            {{ formatDate(item.created) }}
          </td>
          <td>
            <Customer :value="item.customer" />
          </td>
          <td class="employees-col">
            <Employees :value="item.employees" />
          </td>
          <td>
            {{ item.title }}
          </td>
          <td>
            <p class="mb-0 scheduling-time">
              <v-icon
                small
                color="green"
              >
                mdi-calendar-arrow-left
              </v-icon>
              <span class="ml-1">{{ formatDate(item.start) }}</span>
            </p>
            <p class="mb-0 scheduling-time">
              <v-icon
                small
                color="amber"
              >
                mdi-calendar-arrow-right
              </v-icon>
              <span class="ml-1">{{ formatDate(item.end) }}</span>
            </p>
          </td>
          <td>
            <v-chip
              dark
              :color="getStatus(item.status).color"
              class="status-chip"
            >
              <v-icon small v-text="getStatus(item.status).icon" class="mr-2" />
              {{ getStatus(item.status).title }}
            </v-chip>
          </td>
          <td class="actions-col">
            <Actions :schedule="item" @view="$emit('view', item)" @edit="$emit('edit', item)" />
          </td>
        </tr>
      </template>
      <template v-slot:mobile="{ item }">
        <tr
          :key="`mb-${item.id}`"
          @dblclick="$emit('view', item)"
          class="mobile_row table-row"
          :class="getStatus(item.status).class"
        >
          <td class="mobile_col">
            <ul class="flex-content pl-2">
              <li class="flex-item" :data-label="`${lang.scheduler.datatable.headers.id}:`">
                {{ item.id }}
              </li>
              <li class="flex-item" :data-label="`${lang.scheduler.datatable.headers.created}:`">
                {{ formatDate(item.created) }}
              </li>
              <li class="flex-item" :data-label="`${lang.scheduler.datatable.headers.customer}:`">
                <Customer :value="item.customer" />
              </li>
              <li class="flex-item" :data-label="`${lang.scheduler.datatable.headers.employee}:`">
                <Employees :value="item.employees" />
              </li>
              <li class="flex-item" :data-label="`${lang.scheduler.datatable.headers.title}:`">
                {{ item.title }}
              </li>
              <li class="flex-item" :data-label="`${lang.scheduler.datatable.headers.scheduling}:`">
                <p class="mb-0 scheduling-time">
                  <v-icon
                    small
                    color="green"
                  >
                    mdi-calendar-arrow-left
                  </v-icon>
                  <span class="ml-1">{{ formatDate(item.start) }}</span>
                </p>
                <p class="mb-0 scheduling-time">
                  <v-icon
                    small
                    color="amber"
                  >
                    mdi-calendar-arrow-right
                  </v-icon>
                  <span class="ml-1">{{ formatDate(item.end) }}</span>
                </p>
              </li>
              <li class="flex-item" :data-label="`${lang.scheduler.datatable.headers.status}:`">
                <v-chip
                  dark
                  :color="getStatus(item.status).color"
                  class="status-chip"
                >
                  <v-icon small v-text="getStatus(item.status).icon" class="mr-2" />
                  {{ getStatus(item.status).title }}
                </v-chip>
              </li>
              <li class="flex-item actions-row" :data-label="lang.scheduler.datatable.headers.action">
                <Actions :schedule="item" @view="$emit('view', item)" @edit="$emit('edit', item)" />
              </li>
            </ul>
          </td>
        </tr>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from '@/templates/global/DataTable'
import Customer from '@/components/customers/templates/MiniCard'
import Employees from '../launches/templates/Employees'
import Actions from './templates/Actions'

import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import scheduler from '../mixins/index'

export default {
  components: { DataTable, Customer, Employees, Actions },
  mixins: [ appdata, utils, scheduler ],
  data: () => ({
    default: { ...defaults.blank.schedule }
  }),
  computed: {
    items () {
      return (this.get_data.schedules || {}).all || []
    }
  }
}
</script>

<style src="./styles/index.scss" lang="scss"></style>

